import PropTypes from 'prop-types'

export withAuthContext = (component) ->
  component.contextTypes = { auth: PropTypes.object }

  component
